module.exports = __webpack_public_path__ + "static/media/church.25e903f4.svg";